import React, { Component, useState } from "react"
import { Connection, Port, RootState } from ".."
import { PortSVGViewer } from "./PortSVGViewer"
import produce from 'immer'
import { SVGEditorGlobals, View } from "./SVGEditor"
import RBush from "rbush"
import { Barrier } from "../Utils/Barrier"
import { useSelector } from "react-redux"
import { ChannelSVGViewer } from "./ChannelSVGViewer"

export { ConnectionSVGViewer }

function ConnectionSVGViewer(props: {
  connection: Connection
  onChange: (connection: Connection) => void
  globals: SVGEditorGlobals
  barriers: RBush<Barrier>
  fillColor?: string,
  color?: string,
  strokeWidth?: number,
  editable?: boolean
}) {
  const changePort = (index: number) => {
    return (port: Port) => {
      const connection = produce(props.connection, (draft: Connection) => {
        draft.ports[index] = port
      })
      props.onChange(connection)
    }
  }

  const output = useSelector((state: RootState) => state.output)
  const routingResult = output.channels[props.connection.id]

  const  [hover, setHover] = useState(false)

  return <g
      onPointerEnter={() => setHover(true)}
      onPointerLeave={() => setHover(false)}
    >
      {routingResult !== undefined &&
        <ChannelSVGViewer
          key={`channel_${props.connection.id}`}
          connection={props.connection}
          routingResult={routingResult}
          globals={props.globals}
          hover={hover}
          setHover={setHover}
        ></ChannelSVGViewer>
      }
      <PortSVGViewer
        connection={props.connection}
        port={props.connection.ports[0]}
        globals={props.globals}
        onChange={changePort(0)}
        hover={hover}
        setHover={setHover}
      />
      <PortSVGViewer
        connection={props.connection}
        port={props.connection.ports[1]}
        globals={props.globals}
        onChange={changePort(1)}
        hover={hover}
        setHover={setHover}
      />
    </g>
}
